import React from 'react';
import PropTypes from 'prop-types';

import { useSelector, useDispatch } from 'react-redux';
import { highlightFeatures, unhighlightFeatures } from '../../../../redux/highlights/Actions';

import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import PanelContent from '../common/PanelContent';
import Title from '../Title';
import Planning from '../common/planning/Planning';

import { format } from 'date-fns';
import { setFitBounds } from '../../../../redux/map/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';

const useStyles = makeStyles((theme) => style(theme));

const propTypes = {
    // Redux State
    applications: PropTypes.array
};

const defaultProps = {
    applications: null
};

function PlanningReport () {
    const classes = useStyles();
    const report = useSelector((state) => {
        const reducer = state.planningReducer;
        return reducer.planningReports.find(report => report.id === reducer.currentPlanningReportId);
    });
    const planningLayer = useSelector((state) => {
        return state.layers.layers.find(layer => layer.id === 145);
    });
    const dispatch = useDispatch();
    const dispatchHighlightFeature = (highlight) => dispatch(highlightFeatures([highlight]));
    const dispatchUnhighlightFeature = (highlight) => dispatch(unhighlightFeatures([highlight]));
    const dispatchSetFitBounds = (bounds, options = {}) => dispatch(setFitBounds(bounds, options, MAIN_MAP));

    const { id, fromDate, toDate, planningApplications } = report;

    function handlePlanningCardEnter (name) {
        const highlight = {
            key: `${planningLayer.system_name}_report_${id}`,
            layerSystemName: planningLayer.system_name,
            features: [{
                featureId: name
            }],
            styles: planningLayer.styles[0].mapboxStyleSpecification.highlights
        };
        dispatchHighlightFeature(highlight);
    }

    function handlePlanningCardLeave (name) {
        const highlight = {
            key: `${planningLayer.system_name}_report_${id}`,
            layerSystemName: planningLayer.system_name
        };
        dispatchUnhighlightFeature(highlight);
    }

    function handleViewOnMap (coords) {
        dispatchSetFitBounds([coords, coords], { maxZoom: 16 });
    }

    return (<PanelContent>
        { report && !report.isFetching && <>
            <Title title="Overview" />
            <div>
                <Typography color="textPrimary" variant="subtitle1">
                    There are {planningApplications.length} planning applications that are new or updated between {fromDate && format(Date.parse(fromDate), 'dd/MM/yyyy HH:mm:ss')} and {toDate && format(Date.parse(toDate), 'dd/MM/yyyy HH:mm:ss')} for this area
                </Typography>
            </div>
        </>}
        <Planning
            applications={planningApplications}
            PlanningCardProps={{
                onMouseEnter: handlePlanningCardEnter,
                onMouseLeave: handlePlanningCardLeave,
                onViewOnMap: handleViewOnMap
            }}
        />
    </PanelContent>);
}

PlanningReport.propTypes = propTypes;
PlanningReport.defaultProps = defaultProps;

const style = theme => ({

});

export default PlanningReport;